import React, { useState, useEffect } from 'react';
import { Marker, GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import PropTypes from 'prop-types';
import { Button, Modal, Spin, Form, Col, Row } from 'antd';
import { useSelector } from 'react-redux';

import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { GooglePlacesAutocomplete } from '../../../../components/geolocation/GooglePlacesAutocomplete';


const AssetLocalizationModal = ({ assetCoordinates, show, handleClose }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
  });
  const [map, setMap] = useState(null);
  const { translate: t } = useDictionaryTranslation();

  const [form] = Form.useForm();
  const accountData = useSelector((state) => state.auth?.accountData);
  const [centerMap, setCenterMap] = useState({
    lat: accountData?.markerCoords?.latitude || 6.3084807267484475,
    lng: accountData?.markerCoords?.longitude || -75.5045725572256,
  });
  const [address, setAddress] = useState(null);

  const onLoad = React.useCallback((newMap) => {
    setMap(newMap);
  }, []);

  const onUnmount = React.useCallback(() => {
    setMap(null);
  });

  useEffect(() => {
    if (assetCoordinates) {
      setCenterMap({
        lat: assetCoordinates.markerCoords.latitude,
        lng: assetCoordinates.markerCoords.longitude,
      });
      setAddress(assetCoordinates);
      form.setFieldValue('address', assetCoordinates);
    }
  }, [assetCoordinates]);

  const closeModal = () => {
    handleClose(address);
  };

  const handleSetAddress = (value) => {
    setCenterMap({
      lat: value.markerCoords.latitude,
      lng: value.markerCoords.longitude,
    });
    setAddress(value);
  };


  return (
    <Modal
      title={t('selectLocalization')}
      destroyOnClose
      width="40%"
      height="30%"
      onCancel={closeModal}
      visible={show}
      footer={
        <div>
          <Button form="assetLocalizationForm" type="primary" key="submit" htmlType="submit" >
            {t('save')}
          </Button>
        </div>
      }
    >

      <Spin spinning={false}>
        <Form name="assetLocalizationForm" layout="vertical" form={form} onFinish={closeModal}>
          <Row gutter={20}>
            <Col xs={24} md={24}>
              <Form.Item name="address" label={t('address')} rules={[{ required: true }]}>
                <GooglePlacesAutocomplete onChange={handleSetAddress} />
              </Form.Item>
            </Col>

            {
              isLoaded &&
              < GoogleMap
                mapContainerStyle={{
                  width: '100%',
                  height: '40vh',
                }}
                center={centerMap}
                zoom={address && address.markerCoords ? 14 : 10}
                onLoad={onLoad}
                onUnmount={onUnmount}
              >
                {
                  map && address && address.markerCoords &&
                  <Marker
                    position={{ lat: address.markerCoords.latitude, lng: address.markerCoords.longitude }}
                    map={map}
                  />
                }
              </GoogleMap>
            }
          </Row>

        </Form>

      </Spin>
    </Modal >
  );
};

export default AssetLocalizationModal;

AssetLocalizationModal.propTypes = {
  assetCoordinates: PropTypes.object,
  handleClose: PropTypes.func,
  show: PropTypes.bool,
};
